"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerSlice = footerSlice;
const footerInitialState = {
    footer: {
        buttons: [],
    },
};
function footerSlice(set) {
    return {
        ...footerInitialState,
        setFooterButtons(buttons) {
            set((state) => {
                state.footer.buttons = buttons;
                return state;
            }, false, '[setFooterButtons]');
        },
    };
}
